<template>
  <div class="row justify-center">
    <div
      class="card text-center px-1 py-2 m-auto"
      style="width:25rem;"
    >
      <img
        class="card-img-top py-3 px-5"
        src="../assets/images/logo-aequaroma.jpg"
        alt="AEqua Roma"
      >
      <h6>Servizi per gli utenti del Patrimonio Immobiliare di Roma Capitale</h6>
      <h4>Modifica numero mobile di riferimento</h4>
      <div class="d-flex flex-column card-body">
        <b-input
          v-model.trim="numeroMobileCorrente"
          type="text"
          placeholder="Numero Mobile attuale"
          class="m-1"
          aria-required="true"
          :state="fieldNumeroMobile"
          :disabled="true"
          title=" Numero Mobile attuale"
        />
        <b-input
          v-model.trim="numeroMobile"
          type="text"
          placeholder="Numero Mobile (es 3331231234)"
          class="m-1"
          aria-required="true"
          :state="fieldNumeroMobile"
          title=" Prefisso di tre cifre (3##), seguito dal numero telefonico (sei o sette cifre)"
        />
        <!-- <b-form-invalid-feedback v-if="!$v.numeroMobile.required">Campo obbligatorio</b-form-invalid-feedback> -->
        <!-- <b-form-invalid-feedback v-if="!$v.numeroMobile.mobileValidate">Numero mobile non valido</b-form-invalid-feedback> -->
        <b-button
          variant="primary"
          size="lg"
          class="m-1"
          @click="onChangeClick"
        >Cambia</b-button>
        <b-button
          variant="outline-secondary"
          size="lg"
          class="m-1"
          @click="onCancelClick"
        >Annulla</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

const mobileValidate = (value, vm) => {
  // var re = /^([+]39)?((38[{8,9}|0])|(34[{7-9}|0])|(36[6|8|0])|(33[{3-9}|0])|(32[{8,9}]))([\d]{7})$/
  var re = /^((3[{1-9}][{0-9}]))([\d]{6,7})$/
  let retValue = false

  // console.log('value', value)
  // console.log('test value', re.test(value))
  if (re.test(value)) {
    retValue = true
  }

  return retValue
}

export default {

  data: () => {
    return {
      checking: true,
      base: false,
      numeroMobile: '',
      numeroMobileCorrente: ''
    }
  },
  validations: {
    numeroMobile: { required, mobileValidate }
  },

  computed: {
    fieldNumeroMobile () {
      this.$v.numeroMobile.$touch()

      return !this.$v.numeroMobile.$invalid
    }

  },

  async created () {
    await this.load()
  },

  methods: {
    async load () {
      try {
        this.numeroMobileCorrente = this.$store.state.auth.user.mobilephone
        // console.log('numeroMobileCorrente', this.numeroMobileCorrente)
      } catch (err) {
        this.$ui.showError(err)
      }
    },
    onCancelClick () {
      // console.log('user', this.$store.state.auth.user)
      // console.log('codiceFiscale', this.$store.state.auth.user.codiceFiscale)
      this.$router.push({ name: 'home' })
    },
    async onChangeClick () {
      try {
        if (this.validate()) {
          let paramData = {
            codiceFiscale: this.$store.state.auth.user.codiceFiscale,
            numeroCellulare: this.numeroMobile
          }

          // console.log('Parametri change mobile', paramData)
          await this.$store.dispatch('changeMobile', paramData)
          this.$ui.notify({
            type: 'info',
            title: 'Operazione completata',
            message: 'Il numero mobile è stato aggiornato con successo!.'
          })

          this.$store.state.auth.user.mobilephone = this.numeroMobile

          this.$router.push({ name: 'home' })
        } else {
          this.$ui.notify({
            type: 'warning',
            title: 'Dati non corretti',
            message: 'Verificare i dati inseriti.'
          })
        }
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    validate () {
      this.$v.numeroMobile.$touch()

      return !this.$v.numeroMobile.$invalid
    }

  }

}
</script>

<style lang="stylus" scoped></style>
